import {css} from "@panda/css";

import {useFormContextRHF} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";

import {
    HOME_MATCH_PREFERENCES_SURVEY_BUILDING_HEIGHTS,
    HOME_MATCH_PREFERENCES_SURVEY_CONTENT,
    HOME_MATCH_PREFERENCES_SURVEY_FLOOR_ICONS,
    HOME_MATCH_PREFERENCES_SURVEY_FLOORS
} from "../../../constants/preferences/home_match_preferences_survey_content";
import {HomeMatchFloorsPreference} from "../../../constants/preferences/home_match_preferences_values";
import {IHomeMatchPreferencesSurveyForm} from "../../../types/home_match_preferences";
import {toggleHomeMatchFloorsPreference} from "../../../utils/home_match_floors_preference";
import {HomeMatchPreferencesSurveyCard} from "../HomeMatchPreferencesSurveyCard";
import {HomeMatchPreferencesSurveyPill} from "../HomeMatchPreferencesSurveyPill";

const {BUILDING_HEIGHT, FLOOR} = HOME_MATCH_PREFERENCES_SURVEY_CONTENT;

export const HomeMatchPreferencesSurveyFeatureFields = () => {
    const {setValue, watch} = useFormContextRHF<IHomeMatchPreferencesSurveyForm>();
    const floorsPreference = watch("floorsPreference");
    const buildingHeight = watch("buildingHeight");

    const toggleFloor = (value: HomeMatchFloorsPreference) => {
        setValue("floorsPreference", toggleHomeMatchFloorsPreference(floorsPreference, value), {shouldDirty: true});
    };

    return (
        <>
            <div className={fieldStyle}>
                <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                    {FLOOR}
                </Text>
                <div className={floorGridStyle}>
                    {HOME_MATCH_PREFERENCES_SURVEY_FLOORS.map((option) => {
                        const Icon = HOME_MATCH_PREFERENCES_SURVEY_FLOOR_ICONS[option.value];

                        return (
                            <HomeMatchPreferencesSurveyCard
                                icon={<Icon fill="var(--colors-violet-selected)" secondaryFill="var(--colors-violet-light)" size="6.4" />}
                                isSelected={floorsPreference.includes(option.value)}
                                key={option.value}
                                label={option.label}
                                onSelect={() => toggleFloor(option.value)}
                            />
                        );
                    })}
                </div>
            </div>

            <div className={inlineOptionsStyle}>
                <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                    {BUILDING_HEIGHT}
                </Text>
                <div className={pillRowStyle}>
                    {HOME_MATCH_PREFERENCES_SURVEY_BUILDING_HEIGHTS.map((option) => (
                        <HomeMatchPreferencesSurveyPill
                            isSelected={buildingHeight === option.value}
                            key={option.value}
                            label={option.label}
                            onSelect={() => setValue("buildingHeight", buildingHeight === option.value ? null : option.value, {shouldDirty: true})}
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

const fieldStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});

const floorGridStyle = css({
    display: "grid",
    gap: 2,
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",

    md: {
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))"
    }
});

const pillRowStyle = css({
    display: "flex",
    flexWrap: "wrap",
    gap: 1
});

const inlineOptionsStyle = css({
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
    gap: 2,
    justifyContent: "space-between"
});
import {css} from "@panda/css";

import {useFormContextRHF} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";

import {
    HOME_MATCH_PREFERENCES_SURVEY_BUILDING_HEIGHTS,
    HOME_MATCH_PREFERENCES_SURVEY_CONTENT,
    HOME_MATCH_PREFERENCES_SURVEY_FLOOR_ICONS,
    HOME_MATCH_PREFERENCES_SURVEY_FLOORS
} from "../../../constants/preferences/home_match_preferences_survey_content";
import {HomeMatchFloorsPreference} from "../../../constants/preferences/home_match_preferences_values";
import {IHomeMatchPreferencesSurveyForm} from "../../../types/home_match_preferences";
import {toggleHomeMatchFloorsPreference} from "../../../utils/home_match_floors_preference";
import {HomeMatchPreferencesSurveyCard} from "../HomeMatchPreferencesSurveyCard";
import {HomeMatchPreferencesSurveyPill} from "../HomeMatchPreferencesSurveyPill";

const {BUILDING_HEIGHT, FLOOR} = HOME_MATCH_PREFERENCES_SURVEY_CONTENT;

export const HomeMatchPreferencesSurveyFeatureFields = () => {
    const {setValue, watch} = useFormContextRHF<IHomeMatchPreferencesSurveyForm>();
    const floorsPreference = watch("floorsPreference");
    const buildingHeight = watch("buildingHeight");

    const toggleFloor = (value: HomeMatchFloorsPreference) => {
        setValue("floorsPreference", toggleHomeMatchFloorsPreference(floorsPreference, value), {shouldDirty: true});
    };

    return (
        <>
            <div className={fieldStyle}>
                <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                    {FLOOR}
                </Text>
                <div className={floorGridStyle}>
                    {HOME_MATCH_PREFERENCES_SURVEY_FLOORS.map((option) => {
                        const Icon = HOME_MATCH_PREFERENCES_SURVEY_FLOOR_ICONS[option.value];

                        return (
                            <HomeMatchPreferencesSurveyCard
                                icon={<Icon fill="var(--colors-violet-selected)" secondaryFill="var(--colors-violet-light)" size="6.4" />}
                                isSelected={floorsPreference.includes(option.value)}
                                key={option.value}
                                label={option.label}
                                onSelect={() => toggleFloor(option.value)}
                            />
                        );
                    })}
                </div>
            </div>

            <div className={inlineOptionsStyle}>
                <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                    {BUILDING_HEIGHT}
                </Text>
                <div className={pillRowStyle}>
                    {HOME_MATCH_PREFERENCES_SURVEY_BUILDING_HEIGHTS.map((option) => (
                        <HomeMatchPreferencesSurveyPill
                            isSelected={buildingHeight === option.value}
                            key={option.value}
                            label={option.label}
                            onSelect={() => setValue("buildingHeight", buildingHeight === option.value ? null : option.value, {shouldDirty: true})}
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

const fieldStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});

const floorGridStyle = css({
    display: "grid",
    gap: 2,
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",

    md: {
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))"
    }
});

const pillRowStyle = css({
    display: "flex",
    flexWrap: "wrap",
    gap: 1
});

const inlineOptionsStyle = css({
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
    gap: 2,
    justifyContent: "space-between"
});
